// SidebarMenu.jsx
import React from "react";
import { motion } from "framer-motion";
import "../styles/SidebarMenu.css";
import { FiChevronRight } from "react-icons/fi";

const menuItems = ["Nexa Partners", "Nexa Accelerate", "Nexa Elevate"];

const SidebarMenu = ({ onSelectTab, activeTab }) => {
  const getClassName = (item) => {
    const base = "menu-item";
    if (activeTab === item) {
      if (item === "Nexa Partners") return `${base} active partner`;
      if (item === "Nexa Accelerate") return `${base} active accelerate`;
      if (item === "Nexa Elevate") return `${base} active elevate`;
    }
    return base;
  };

  return (
    <div className="sidebar-menu">
      {menuItems.map((item, index) => (
        <motion.div
          key={index}
          className={getClassName(item)}
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: index * 0.2, duration: 0.5 }}
          whileHover={{ scale: 1.03 }}
          onClick={() => onSelectTab(item)}
        >
          <span>{item}</span>
          <FiChevronRight className="chevron-icon" />
        </motion.div>
      ))}
    </div>
  );
};

export default SidebarMenu;
